<section class="max-w-6xl mx-auto p-4 md:p-10 min-h-screen">
  @if (addresses().length > 0) {
    <div class="flex items-center justify-between gap-4 mb-10">
      <h2 class="text-xl md:text-2xl font-bold text-gray-800">
        {{ 'Shipping Address' | translate }}
      </h2>

      <button
        (click)="addNewAddress()"
        class="flex items-center justify-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg transition font-medium shadow-sm border border-gray-200"
      >
        <sham-i-plus-03 />

        <span class="hidden md:inline">{{
          'Add new Shipping address' | translate
        }}</span>
        <span class="md:hidden text-sm">{{ 'New address' | translate }}</span>
      </button>
    </div>

    <div class="space-y-2">
      @for (addr of addresses(); track addr.id; let i = $index) {
        <div
          class="flex items-center gap-4 py-6 border-b border-gray-100 last:border-b-0 group"
        >
          <div class="pt-1">
            <input
              type="radio"
              [id]="'addr-' + i"
              name="shipping-address"
              [checked]="selectedAddressId() === addr.id"
              [disabled]="!addr.isDeliveryReady"
              (change)="selectAddress(addr)"
              class="w-5 h-5 cursor-pointer accent-[#2596BE] disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>

          <div class="flex-1 space-y-1">
            <div class="flex items-center gap-3 flex-wrap justify-between">
              <div class="flex items-center gap-3 flex-wrap">
                <label
                  [for]="'addr-' + i"
                  class="font-medium text-base cursor-pointer"
                >
                  {{ addr.fullName }}
                </label>

                @if (addr.isDefault) {
                  <span
                    class="bg-[#F77B61] text-white text-2xs px-2 py-0.5 rounded font-medium"
                  >
                    {{ 'Default' | translate }}
                  </span>
                }
                @if (!addr.isDeliveryReady) {
                  <span
                    class="rounded bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700"
                  >
                    {{ 'addressReadiness.notReady' | translate }}
                  </span>
                }
              </div>
              <div class="flex items-center justify-center gap-4">
                <button
                  (click)="editAddress(addr)"
                  class="flex md:hidden items-center gap-1 px-2 py-1.5 rounded-sm text-[#161616] text-xs bg-[#F3F4F6] hover:bg-gray-50"
                >
                  <sham-i-edit-01 />
                  {{ 'Edit' | translate }}
                </button>
                <button
                  (click)="deleteAddress(addr.id)"
                  class="flex md:hidden items-center gap-1 px-2 py-1 rounded-sm text-[#912018] text-xs bg-[#F7E2E1] hover:bg-red-100"
                >
                  <sham-i-delete-02 />
                </button>
              </div>
            </div>

            <p class="text-gray-700 text-sm md:text-base leading-relaxed max-w-2xl">
              {{ addr.streetAddress }}
            </p>

            <p class="text-gray-700 text-sm md:text-base leading-relaxed max-w-2xl">
              {{ 'phone number' | translate }} {{ addr.phone }}
            </p>
          </div>

          <div class="flex items-center justify-center gap-4">
            <button
              (click)="editAddress(addr)"
              class="hidden md:flex items-center gap-2 px-3 py-2 text-[#161616] rounded-sm text-sm font-medium bg-[#F3F4F6] hover:bg-gray-50"
            >
              <sham-i-edit-01 />
              {{ 'Edit Address' | translate }}
            </button>
            <button
              (click)="deleteAddress(addr.id)"
              class="hidden md:flex items-center gap-2 px-3 py-1.5 text-[#912018] rounded-sm text-sm font-medium bg-[#F7E2E1] hover:bg-red-100"
            >
              <sham-i-delete-02 />
              {{ 'Delete Address' | translate }}
            </button>
          </div>
        </div>
      }
    </div>

    @if (selectionErrorKey(); as errorKey) {
      <div class="mt-5 rounded-lg border border-red-200 bg-red-50 p-4" role="alert">
        <p class="text-sm text-red-800">{{ errorKey | translate }}</p>
      </div>
    }

    <div
      class="flex flex-col-reverse lg:flex-row justify-end items-stretch lg:items-center gap-4 mt-12"
    >
      <button
        (click)="goBack()"
        class="px-10 py-2.5 bg-[#C2C2C2] hover:bg-gray-300 text-[#FEFEFE] rounded-lg transition"
      >
        {{ 'Cancel' | translate }}
      </button>

      <button
        (click)="confirmSelection()"
        [disabled]="!selectedAddressId()"
        class="px-10 py-2.5 bg-[#2596BE] hover:bg-[#1a7a9c] text-[#FEFEFE] rounded-lg transition shadow-md disabled:bg-gray-300 disabled:cursor-not-allowed"
      >
        {{ 'Confirm' | translate }}
      </button>
    </div>
  } @else {
    <app-empty-page
      [imageSrc]="'/assets/images/addresses-empty-state-bg.svg'"
      [message]="'No addresses yet'"
      [buttonText]="'Add Address'"
      [buttonLink]="'/shipping-address-form'"
    />
  }
</section>
